import { Archive } from "lucide-react";
import { Button } from "../ui/button";

/**
 * Floating header row above the History table when one or more jobs are
 * checkbox-selected. Shows the count and offers a single bulk-archive button.
 * Renders nothing when nothing is selected, so the parent can render it
 * unconditionally inside the table card.
 */
export default function HistoryBulkBar({
  selectedCount,
  onClear,
  onArchiveSelected,
  archivingBulk,
}) {
  if (selectedCount === 0) return null;
  return (
    <div
      className="flex items-center justify-between gap-3 px-3 py-2 bg-violet-50 dark:bg-violet-950/30 border-b border-violet-200 dark:border-violet-900"
      data-testid="history-bulk-action-bar"
    >
      <div className="text-sm font-semibold text-violet-900 dark:text-violet-100">
        {selectedCount} job{selectedCount === 1 ? "" : "s"} selected
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onClear}
          data-testid="history-bulk-clear-selection-btn"
        >
          Clear
        </Button>
        <Button
          size="sm"
          onClick={onArchiveSelected}
          disabled={archivingBulk}
          className="bg-slate-900 hover:bg-slate-800 text-white border border-slate-800 dark:bg-transparent dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:border-slate-500 dark:hover:text-white"
          data-testid="history-bulk-archive-btn"
        >
          <Archive className="h-3.5 w-3.5 mr-1.5" />
          {archivingBulk ? "Archiving…" : `Archive ${selectedCount}`}
        </Button>
      </div>
    </div>
  );
}
